module.exports = __webpack_public_path__ + "img/intourist2017-min.a44ea6a1.jpg";